import { atom } from "recoil";

export const agmtTableData = atom({
  key: "agmtTableData",
  default: [],
});

export const searchedAgmtTableData = atom({
  key: "searchedAgmtTableData",
  default: [],
});

export const searchedAgmtGroupedData = atom({
  key: "searchedAgmtGroupedData",
  default: [
    {
      agreementRepositoryId: "",
      carrier: "",
      effectiveDate: null,
      expirationDate: "",
      newPercentage: 0,
      newPercentageConfie: 0,
      newPercentageFranchise: 0,
      renewPercentageConfie: 0,
      renewPercentageFranchise: 0,
      renewalPercentage: 0,
      isFranchise: true,
    },
  ],
});

export const defaultAgmtGrouped = {
  agreementRepositoryId: "",
  carrier: "",
  masterCarrierId: "",
  newPercentage: "",
  renewalPercentage: "",
  newPercentageConfie: "",
  newPercentageFranchise: "",
  renewPercentageConfie: "",
  renewPercentageFranchise: "",
  flatRatePerPolicy: false,
  newFlatRate: 0,
  renewalFlatRate: 0,
  effectiveDate: "",
  expirationDate: "",
};
export const agmtGroupedData = atom({
  key: "agmtGroupedData",
  default: defaultAgmtGrouped,
});

export const agmtGroupedDetails = atom({
  key: "agmtGroupedDetails",
  default: [],
});

export const agmtShowGroupState = atom({
  key: "agmtShowGroupState",
  default: false,
});
export const agmtAddState = atom({
  key: "agmtAddState",
  default: false,
});
export const agmtEditState = atom({
  key: "agmtEditState",
  default: false,
});
export const agmtEditMainState = atom({
  key: "agmtEditMainState",
  default: false,
});

export const isOpenFilter = atom({
  key: "isOpenFilter",
  default: false,
});
export const isFilteredState = atom({
  key: "isFilteredState",
  default: false,
});

export const isFilteredGroup = atom({
  key: "isFilteredGroup",
  default: false,
});

const defaultAgmtParams = {
  AgreementRepositoryId: [],
  AgencyList: [],
  Carrier: [],
  CarrierId: [],
  Commission: null,
  EntityList: [],
  EffectiveDateTo: null,
  EffectiveDateFrom: null,
  ExpirationDate: null,
  AgreementIsActive: null,
  IsFranchise: null,
  PolicyType: [],
  SalesLead: null,
  State: [],
  masterLegalEntityId: null,
  isWritingNewBusiness: null,
};
const defaultGrpAgmtParams = {
  AgreementRepositoryId: [],
  AgencyList: [],
  Commission: null,
  EntityList: [],
  EffectiveDateTo: null,
  EffectiveDateFrom: null,
  ExpirationDate: null,
  AgreementIsActive: null,
  IsFranchise: null,
  PolicyType: [],
  SalesLead: null,
  State: [],
  masterLegalEntityId: null,
  isWritingNewBusiness: null,
};
export const agmtFilterParams = atom({
  key: "agmtFilterParams",
  default: defaultAgmtParams,
});
export const agmtFilterValues = atom({
  key: "agmtFilterValues",
  default: defaultAgmtParams,
});
export const agmtGrpFilterParams = atom({
  key: "agmtGrpFilterParams",
  default: defaultGrpAgmtParams,
});
export const agmtGrpFilterValues = atom({
  key: "agmtGrpFilterValues",
  default: defaultGrpAgmtParams,
});

export const agmtEditMassUpload = atom({
  key: "agmtEditMassUpload",
  default: false,
});

export const agreementMainForEdit = atom({
  key: "agreementMainForEdit",
  default: defaultAgmtGrouped,
});
export const agreementForEdit = atom({
  key: "agreementForEdit",
  default: [],
});
export const allStates = atom({
  key: "allStates",
  default: [],
});
export const stateSelectedState = atom({
  key: "stateSelectedStateAgreements",
  default: null,
});

export const filteredAgreementData = atom({
  key: "filteredAgreementData",
  default: [],
});

export const filteredAgrmtGroupData = atom({
  key: "filteredAgrmtGroupData",
  default: [],
});
export const agmtMassUploadData = atom({
  key: "agmtMassUploadData",
  default: [],
});

export const agmtAllMassUploadData = atom({
  key: "agmtAllMassUploadData",
  default: [],
});

export const agmtCommisions = atom({
  key: "agmtCommisions",
  default: [],
});

export const agmtSelectedStates = atom({
  key: "agmtSelectedStates",
  default: [],
});
export const agmtSelectedRows = atom({
  key: "agmtSelectedRows",
  default: [],
});

export const enableGetAgmt = atom({
  key: "enableGetAgmt",
  default: false,
});

export const agmtFullView = atom({
  key: "agmtFullView",
  default: false,
});

const defaultRowData = {
  agency: "",
  agreementRepositoryId: 0,
  newBusinessFlatRate: 0,
  renewalFlatRate: 0,
  billing: "",
  businessTypeId: 0,
  businessTypeName: "",
  carrier: "",
  carrierContact: undefined,
  commissionEffectiveDate: undefined,
  commissionExpirationDate: undefined,
  commissionPaymentsFrequency: undefined,
  commissionUpdatedBy: undefined,
  commissionUpdatedOn: undefined,
  contactAddress: undefined,
  contactEmailAddress: undefined,
  contactName: undefined,
  contactNumber: undefined,
  contactTypeId: undefined,
  contingentCommission: undefined,
  createdBy: "",
  createdOn: "",
  effectiveDate: "",
  entityEIN: undefined,
  entityId: undefined,
  entityName: "",
  expirationDate: undefined,
  filePath: undefined,
  flatRatePerPolicy: undefined,
  isActive: true,
  agreementIsActive: true,
  isFranchise: false,
  licenseNumber: undefined,
  licenseTypeName: undefined,
  licensedTypeId: undefined,
  lineOfBusinessId: undefined,
  lineOfBusinessName: undefined,
  masterCarrierId: 0,
  newPercentage: 0,
  newPercentageConfie: 0,
  newPercentageFranchise: 0,
  notes: "",
  otherCommissionPercentage: undefined,
  otherCommissionTransaction: undefined,
  otherInsurance: undefined,
  paidType: "",
  paymentRemittanceType: undefined,
  pifMax: undefined,
  pifMin: undefined,
  planCode: undefined,
  policyPrefix: undefined,
  policyType: undefined,
  producerCode: undefined,
  program: undefined,
  renewPercentageConfie: 0,
  renewPercentageFranchise: 0,
  renewalPercentage: 0,
  riskTypeId: undefined,
  riskTypeName: undefined,
  salesLead: undefined,
  salesLeadName: undefined,
  sourceFileId: undefined,
  sourceFileLink: undefined,
  sourceFiles: undefined,
  sourceLink: undefined,
  standard: undefined,
  state: "",
  term: undefined,
  updatedBy: undefined,
  updatedOn: undefined,
  masterEntityName: undefined,
  isWritingNewBusiness: false,
  oldAgreementRepositoryId: undefined,
};

export const agmtRowData = atom({
  key: "agmtRowData",
  default: defaultRowData,
});

export const agmtToExpire = atom({
  key: "agmtToExpire",
  default: false,
});

export const editRenewedAgmt = atom({
  key: "editRenewedAgmt",
  default: false,
});

export const enableGetCommQuery = atom({
  key: "enableGetCommQuery",
  default: false,
});

export const conflictingAgreementId = atom({
  key: "conflictingAgreementId",
  default: [],
});

export const filterConflictingAgreement = atom({
  key: "filterConflictingAgreement",
  default: false,
});

export const agreementFormData = atom({
  key: "agreementFormData",
  default: [],
});

export const pendingEditRow = atom({
  key: "pendingEditRow",
  default: null,
});
